var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{
    'btn-disabled': _vm.disabled,
    'btn-primary': _vm.primary,
    'btn-secondary': _vm.secondary,
    'btn-campaign': _vm.campaign,
    'btn-small': _vm.small,
    'btn-mini': _vm.mini,
    'btn-medium': _vm.medium,
    'btn-large': _vm.large,
    'btn-x-large': _vm.xLarge,
    'btn-wide': _vm.wide,
    'subtitle-1': _vm.large || _vm.medium,
    'subtitle-2': _vm.small,
    'btn-border': _vm.border,
    'btn-no-border': _vm.noBorder,
    h5: _vm.wide,
  },attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }